import APIService from "./APIService";

class HomeDeliveryService extends APIService {
  getMarkets = async () => {
    const result = await this.get("markets/get-markets");
    return result ? result.data : null;
  };

  getCartData = async (search: string = "", page: number, limit: number, category_id: string, branch_id: string) => {
    const branch = branch_id ? `${"&branch_id=" + branch_id}` : "";
    const result = await this.get(
      "home-delivery/cart?generic=" + search + "&page=" + page + "&limit=" + limit + "&category_id=" + category_id + branch
    );
    return result ? result.data : null;
  };

  search = async (search: string = "", page: number = 1, limit: number = 10, sort: string, status: string) => {
    const result = await this.get(
      "home-delivery/search?generic=" + search + "&page=" + page + "&limit=" + limit + "&sort=" + sort + "&status=" + status
    );
    return result ? result.data : null;
  };

  getDiscounts = async (branch_id: string) => {
    const result = await this.get("home-delivery/get-discounts?branch_id=" + branch_id);
    return result ? result.data : null;
  };

  createOrder = async (
    discounts: any[],
    payment_options: string[],
    branch_id: string,
    customer_id: string,
    products: any[],
    teller: { _id: string; first_name: string; last_name: string },
    order_type?: string,
    order_status?: string,
    delivery_date?: Date,
    delivery_time?: Date,
    delivery_notes?: string,
    delivery_address?: {
      address_1: string;
      address_2: string;
      city: string;
      state: string;
      zip_code: string;
      country: string;
    },
    qualified_programs?: string[]
  ) => {
    const result = await this.post(
      {
        discounts,
        payment_options,
        branch_id,
        customer_id,
        products,
        teller,
        order_type,
        order_status,
        delivery_date,
        delivery_time,
        delivery_notes,
        delivery_address,
        qualified_programs,
      },
      "home-delivery"
    );
    return result ? result.data : null;
  };

  getProductNames = async (query: string) => {
    const result = await this.get("products/lists?query=" + query);
    return result ? result.data : null;
  };

  getOrder = async (id: string) => {
    const result = await this.get("home-delivery/order?id=" + id);
    return result ? result.data : null;
  };

  updateCustomerAddress = async (customer_id: string, address: any) => {
    const result = await this.put(
      {
        customer_id,
        address,
      },
      "home-delivery/update-customer-address"
    );
    return result ? result.data : null;
  };

  verifyCode = async (branch_id: string, code: string) => {
    const result = await this.get("home-delivery/code?branch_id=" + branch_id + "&code=" + code);
    return result ? result.data : null;
  };

  updateOrder = async (order_id: string, status: string, reason: string) => {
    const result = await this.put(
      {
        order_id,
        status,
        reason,
      },
      "home-delivery/update-order"
    );
    return result ? result.data : null;
  };
}

export default HomeDeliveryService;
